import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { initiateAuth } from "../services/auth";
import { LoadingCircle } from "./Common/loading";
import { isValidEmail } from "../utils/emailValidator";
import ZownIcon from "../assets/zown-logo-blue-wide.svg";
import { usePersonalInfoStore } from "../stores/personalInformationStore";

const EmailView = () => {
  const [localEmail, setLocalEmail] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { setEmail } = usePersonalInfoStore();
  const [loading, setLoading] = useState(false);

  const handleCreateAccount = async () => {
    if (isValidEmail(localEmail)) {
      try {
        setError("");
        setEmail(localEmail);
        setLoading(true);
        await initiateAuth(localEmail);
        setLoading(false);
        navigate("/login/verify", { state: { origin: "emailView" } });
      } catch (error) {
        setLoading(false);
        console.error("Failed to initiate auth:", error);
        navigate("/login/verify", { state: { origin: "emailView" } });
      }
    } else {
      setError("Please enter a valid email address.");
    }
  };

  return (
    <div className="absolute inset-0 flex w-full justify-center px-4">
      <div className="w-[500px] h-full flex flex-col justify-center items-center space-y-5">
        <img src={ZownIcon} alt="" className="w-[131px]" />
        <div className="font-bold text-2xl text-z-prussian-blue">
          Let's get started
        </div>
        {loading && (
          <div className="w-full flex items-center justify-center">
            <LoadingCircle />
          </div>
        )}
        {!loading && (
          <div className="space-y-4 w-full">
            <div>
              <label
                htmlFor="email"
                className="block mb-2 text-sm font-medium text-black"
              >
                Email
              </label>
              <input
                type="email"
                name="email"
                id="email"
                value={localEmail}
                onChange={(e) => setLocalEmail(e.target.value.toLowerCase())}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5"
                placeholder="name@example.com"
                required={true}
              />
              {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
            </div>

            <button
              type="button"
              onClick={handleCreateAccount}
              className="w-full text-white bg-z-prussian-blue font-medium rounded-lg text-sm px-5 py-2.5 text-center"
            >
              Create account
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export { EmailView };
